/* tslint:disable */
/* eslint-disable */
/**
 * Optimizely Feature Experimentation API
 * This page documents how to use the Optimizely FX API. With this API you can view and manage Feature Flags and all of their related entities including Variables, Variations, Rules, and Reports.  The base URL is https://api.optimizely.com/flags/v1. Append any paths listed in these docs onto that url in order to make requests to the API.
 *
 * The version of the OpenAPI document: 0.3.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BrainstormVariablesChat,
    BrainstormVariablesChatFromJSON,
    BrainstormVariablesChatToJSON,
    PatchRequestBody,
    PatchRequestBodyFromJSON,
    PatchRequestBodyToJSON,
    ProblemDetail,
    ProblemDetailFromJSON,
    ProblemDetailToJSON,
    VariableDefinition,
    VariableDefinitionFromJSON,
    VariableDefinitionToJSON,
    VariableDefinitions,
    VariableDefinitionsFromJSON,
    VariableDefinitionsToJSON,
} from '../models';

export interface BrainstormVariableDefinitionsRequest {
    project_id: number;
    flag_key: string;
    brainstorm_variables_chat: BrainstormVariablesChat;
}

export interface CreateVariableDefinitionRequest {
    flag_key: string;
    project_id: number;
    variable_definition: VariableDefinition;
}

export interface DeleteVariableDefinitionRequest {
    project_id: number;
    flag_key: string;
    variable_definition_key: string;
}

export interface FetchVariableDefinitionRequest {
    project_id: number;
    flag_key: string;
    variable_definition_key: string;
}

export interface ListVariableDefinitionsRequest {
    project_id: number;
    flag_key: string;
    per_page?: number;
    page_number?: number;
    page_token?: string;
    page_window?: number;
    sort?: Array<ListVariableDefinitionsSortEnum>;
}

export interface UpdateVariableDefinitionsRequest {
    project_id: number;
    flag_key: string;
    patch_request_body: Array<PatchRequestBody>;
}

/**
 * no description
 */
export class VariableDefinitionsApi extends runtime.BaseAPI {

    /**
     * Brainstorm variable definitions using AI.
     */
    async brainstormVariableDefinitionsRaw(requestParameters: BrainstormVariableDefinitionsRequest): Promise<runtime.ApiResponse<BrainstormVariablesChat>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling brainstormVariableDefinitions.');
        }

        if (requestParameters.flag_key === null || requestParameters.flag_key === undefined) {
            throw new runtime.RequiredError('flag_key','Required parameter requestParameters.flag_key was null or undefined when calling brainstormVariableDefinitions.');
        }

        if (requestParameters.brainstorm_variables_chat === null || requestParameters.brainstorm_variables_chat === undefined) {
            throw new runtime.RequiredError('brainstorm_variables_chat','Required parameter requestParameters.brainstorm_variables_chat was null or undefined when calling brainstormVariableDefinitions.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/projects/{project_id}/flags/{flag_key}/variable_definitions/brainstorm`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))).replace(`{${"flag_key"}}`, encodeURIComponent(String(requestParameters.flag_key))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BrainstormVariablesChatToJSON(requestParameters.brainstorm_variables_chat),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => BrainstormVariablesChatFromJSON(jsonValue));
    }

    /**
     * Brainstorm variable definitions using AI.
     */
    async brainstormVariableDefinitions(requestParameters: BrainstormVariableDefinitionsRequest): Promise<BrainstormVariablesChat> {
        const response = await this.brainstormVariableDefinitionsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create Variable Definition 
     * Create Variable Definition
     */
    async createVariableDefinitionRaw(requestParameters: CreateVariableDefinitionRequest): Promise<runtime.ApiResponse<VariableDefinition>> {
        if (requestParameters.flag_key === null || requestParameters.flag_key === undefined) {
            throw new runtime.RequiredError('flag_key','Required parameter requestParameters.flag_key was null or undefined when calling createVariableDefinition.');
        }

        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling createVariableDefinition.');
        }

        if (requestParameters.variable_definition === null || requestParameters.variable_definition === undefined) {
            throw new runtime.RequiredError('variable_definition','Required parameter requestParameters.variable_definition was null or undefined when calling createVariableDefinition.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/projects/{project_id}/flags/{flag_key}/variable_definitions`.replace(`{${"flag_key"}}`, encodeURIComponent(String(requestParameters.flag_key))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VariableDefinitionToJSON(requestParameters.variable_definition),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => VariableDefinitionFromJSON(jsonValue));
    }

    /**
     * Create Variable Definition 
     * Create Variable Definition
     */
    async createVariableDefinition(requestParameters: CreateVariableDefinitionRequest): Promise<VariableDefinition> {
        const response = await this.createVariableDefinitionRaw(requestParameters);
        return await response.value();
    }

    /**
     * Permanently delete a Variable Definition for a Flag. There will be no way to access this data after deletion. 
     * Delete a Variable Definition
     */
    async deleteVariableDefinitionRaw(requestParameters: DeleteVariableDefinitionRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling deleteVariableDefinition.');
        }

        if (requestParameters.flag_key === null || requestParameters.flag_key === undefined) {
            throw new runtime.RequiredError('flag_key','Required parameter requestParameters.flag_key was null or undefined when calling deleteVariableDefinition.');
        }

        if (requestParameters.variable_definition_key === null || requestParameters.variable_definition_key === undefined) {
            throw new runtime.RequiredError('variable_definition_key','Required parameter requestParameters.variable_definition_key was null or undefined when calling deleteVariableDefinition.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/projects/{project_id}/flags/{flag_key}/variable_definitions/{variable_definition_key}`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))).replace(`{${"flag_key"}}`, encodeURIComponent(String(requestParameters.flag_key))).replace(`{${"variable_definition_key"}}`, encodeURIComponent(String(requestParameters.variable_definition_key))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Permanently delete a Variable Definition for a Flag. There will be no way to access this data after deletion. 
     * Delete a Variable Definition
     */
    async deleteVariableDefinition(requestParameters: DeleteVariableDefinitionRequest): Promise<void> {
        await this.deleteVariableDefinitionRaw(requestParameters);
    }

    /**
     * Fetch a single variable definition by its key.
     */
    async fetchVariableDefinitionRaw(requestParameters: FetchVariableDefinitionRequest): Promise<runtime.ApiResponse<VariableDefinition>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling fetchVariableDefinition.');
        }

        if (requestParameters.flag_key === null || requestParameters.flag_key === undefined) {
            throw new runtime.RequiredError('flag_key','Required parameter requestParameters.flag_key was null or undefined when calling fetchVariableDefinition.');
        }

        if (requestParameters.variable_definition_key === null || requestParameters.variable_definition_key === undefined) {
            throw new runtime.RequiredError('variable_definition_key','Required parameter requestParameters.variable_definition_key was null or undefined when calling fetchVariableDefinition.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/projects/{project_id}/flags/{flag_key}/variable_definitions/{variable_definition_key}`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))).replace(`{${"flag_key"}}`, encodeURIComponent(String(requestParameters.flag_key))).replace(`{${"variable_definition_key"}}`, encodeURIComponent(String(requestParameters.variable_definition_key))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => VariableDefinitionFromJSON(jsonValue));
    }

    /**
     * Fetch a single variable definition by its key.
     */
    async fetchVariableDefinition(requestParameters: FetchVariableDefinitionRequest): Promise<VariableDefinition> {
        const response = await this.fetchVariableDefinitionRaw(requestParameters);
        return await response.value();
    }

    /**
     * Fetch all variable definitions for flag.
     */
    async listVariableDefinitionsRaw(requestParameters: ListVariableDefinitionsRequest): Promise<runtime.ApiResponse<VariableDefinitions>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling listVariableDefinitions.');
        }

        if (requestParameters.flag_key === null || requestParameters.flag_key === undefined) {
            throw new runtime.RequiredError('flag_key','Required parameter requestParameters.flag_key was null or undefined when calling listVariableDefinitions.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.per_page !== undefined) {
            queryParameters['per_page'] = requestParameters.per_page;
        }

        if (requestParameters.page_number !== undefined) {
            queryParameters['page_number'] = requestParameters.page_number;
        }

        if (requestParameters.page_token !== undefined) {
            queryParameters['page_token'] = requestParameters.page_token;
        }

        if (requestParameters.page_window !== undefined) {
            queryParameters['page_window'] = requestParameters.page_window;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/projects/{project_id}/flags/{flag_key}/variable_definitions`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))).replace(`{${"flag_key"}}`, encodeURIComponent(String(requestParameters.flag_key))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => VariableDefinitionsFromJSON(jsonValue));
    }

    /**
     * Fetch all variable definitions for flag.
     */
    async listVariableDefinitions(requestParameters: ListVariableDefinitionsRequest): Promise<VariableDefinitions> {
        const response = await this.listVariableDefinitionsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update one or more Variable Definitions in a project using a json patch structure.  Properties that are readOnly that are present in the request body will be ignored as well as unknown properties. 
     * Update Variable Definitions
     */
    async updateVariableDefinitionsRaw(requestParameters: UpdateVariableDefinitionsRequest): Promise<runtime.ApiResponse<VariableDefinitions>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling updateVariableDefinitions.');
        }

        if (requestParameters.flag_key === null || requestParameters.flag_key === undefined) {
            throw new runtime.RequiredError('flag_key','Required parameter requestParameters.flag_key was null or undefined when calling updateVariableDefinitions.');
        }

        if (requestParameters.patch_request_body === null || requestParameters.patch_request_body === undefined) {
            throw new runtime.RequiredError('patch_request_body','Required parameter requestParameters.patch_request_body was null or undefined when calling updateVariableDefinitions.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/projects/{project_id}/flags/{flag_key}/variable_definitions`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))).replace(`{${"flag_key"}}`, encodeURIComponent(String(requestParameters.flag_key))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.patch_request_body.map(PatchRequestBodyToJSON),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => VariableDefinitionsFromJSON(jsonValue));
    }

    /**
     * Update one or more Variable Definitions in a project using a json patch structure.  Properties that are readOnly that are present in the request body will be ignored as well as unknown properties. 
     * Update Variable Definitions
     */
    async updateVariableDefinitions(requestParameters: UpdateVariableDefinitionsRequest): Promise<VariableDefinitions> {
        const response = await this.updateVariableDefinitionsRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListVariableDefinitionsSortEnum {
    Keyasc = 'key:asc',
    Keydesc = 'key:desc',
    Typeasc = 'type:asc',
    Typedesc = 'type:desc'
}
